// eventEmitter.js
import EventEmitter from 'eventemitter3';

const globalEventEmitter = new EventEmitter();

export default globalEventEmitter;
